import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { find } from 'lodash';

import Img from '../../Img';
import Location from '../Location';
import AddEventToCalendar from '../../AddToCalander';
import { PowerFunnelSurfaces } from '../../Analytics/constants';

const _ = { find };

const RegConfirmation = (props) => {
    const { currentEvent } = props.events;
    const { data: event } = currentEvent;
    const { user, regConfirmation } = props;
    const registeredToPaidDivisions = event && _.find(event.eventDivisions, ed => ed.registered && (ed.price !== 'Free'));
    const registeredToDoublesDivisions = event && _.find(event.eventDivisions, ed => ed.registered && (ed.divisionFormatType.value === 'doubles'));

    return (
        <div className="row">
            <div className="col-md-8">
                <h4 className="d-flex d-md-none mt48 aic text-semi"><Img src="/img/v2/icons/icon-valid-grad.svg" className="h48 mr16" /> {`You're registered!`}</h4>
                <h5 className="d-none d-md-flex mt48 aic"><Img src="/img/v2/icons/icon-valid-grad.svg" className="h48 mr16" /> {`You're registered!`}</h5>
                <p className="text-medium text-dark mt32 d-none d-md-block">What’s next?</p>
                <p className="mt20 d-none d-md-block">{`You're all set!`}</p>
                {(registeredToPaidDivisions && event.allowOffPlatformPayments) && (
                    <p className="text-medium text-dark mt20 d-none d-md-block">Don’t forget your entry fee(s) will be collected directly by club.</p>
                )}
                {(registeredToDoublesDivisions) && (
                    <p className="mt20 d-none d-md-block">If you had to enter an email for your doubles
                        partner, please follow up with them to ensure they complete their
                        registration.
                    </p>
                )}
                <p className="mt20 d-none d-md-block">Check your email for updates from the event provider.</p>
                <p className="mt20 d-none d-md-block">Have fun!</p>

                {/* <div className="notification-card mt32">
                    <div className="text-highlight3 mb8">IMPORTANT</div>
                    <p className="text-dark text-medium">Please make sure your doubles partner signs up for UTR Sports.<br />Once they join, you'll be added to the draw.</p>
                    </div>
                */}

                <p className="text-medium text-dark mt32">Key Dates</p>
                <ul>
                    {event?.eventSchedule.drawsPublishedShort && (
                        <li>Draws Posted: {event?.eventSchedule.drawsPublishedShort}</li>
                    )}
                    {event?.eventSchedule.eventStartShort && (
                        <li>Event Start Date: {event?.eventSchedule.eventStartShort}</li>
                    )}
                    {event?.eventSchedule.eventEndShort && (
                        <li>Event End Date: {event?.eventSchedule.eventEndShort}</li>
                    )}
                </ul>
                <AddEventToCalendar showOnLoad={regConfirmation} uiElement={'button'} eventDetails={event} loggedInUserId={user?.id} />
                <div className="mt24">
                    <Link className="d-inline mt24" onClick={props.backToEvent}>View the event</Link>&nbsp;|&nbsp;
                    <Link className="d-inline mt24" to={`/home`}>Return to home dashboard</Link>
                </div>
            </div>
            <div className="col-md-4">
                <h6 className="text-uppercase">Tournament Location</h6>
                {event && (
                    <Location
                        event={event}
                        surface={PowerFunnelSurfaces.EVENT_GP_FIND_ACCOMMODATIONS_REGISTRATION_CONFIRMATION}
                        data-testid="event.reg-confirmation.location"
                    />
                )}
            </div>
        </div>
    );
};

function mapStateToProps({ events, auth: { user } }) {
    return { events, user };
}

export default connect(mapStateToProps, null)(RegConfirmation);
